import { useEffect, useState, useCallback } from 'react';
import usePendoInformation from 'features/loggedInRoutesPanel/usePendoInformation';
import { differenceInDays } from 'date-fns';

export const calculateDaysLeft = (expirationDate: Date, currentDate: Date): number => differenceInDays(expirationDate, currentDate);

const useTrialExpirationDaysLeft = (): number => {
    const getPendoInformation = usePendoInformation();
    const [daysLeft, setDaysLeft] = useState<number>(0);

    const fetchDaysLeft = useCallback(async () => {
        try {
            const pendoInformation = await getPendoInformation();
            const { trialExpirationDate } = pendoInformation.account;
            const trialDaysLeft = calculateDaysLeft(new Date(trialExpirationDate), new Date());
            setDaysLeft(trialDaysLeft);
        } catch (ex) {
            console.error('failed to fetch pendo information', ex);
        }
    }, [getPendoInformation]);

    useEffect(() => {
        fetchDaysLeft();
    }, [fetchDaysLeft]);

    return daysLeft;
}

export default useTrialExpirationDaysLeft;